import apiClient from '$utils/apiClient';
import { clientInfoHeader } from '$utils/clientInfo';

const BASE_URL = 'assessment-items';

const assessmentItemsApi = async ({
  method = 'GET',
  accessToken,
  params,
  url = BASE_URL,
  data = {},
  headers = {},
  withCredentials,
}) =>
  apiClient({
    method,
    url,
    headers: {
      Authorization: `Bearer ${accessToken}`,
      ...clientInfoHeader,
      ...headers,
    },
    params,
    data,
    withCredentials,
  });

export const getAssessmentItemsBySpaceId = async ({ spaceId, accessToken }) => {
  const { data } = await assessmentItemsApi({
    accessToken,
    params: { space: spaceId },
  });

  return data;
};

export const postAssignmentsToAssessmentItem = async ({
  assessmentItemId,
  assignmentMappings,
  accessToken,
}) => {
  const { data } = await assessmentItemsApi({
    method: 'post',
    accessToken,
    url: `${BASE_URL}/${assessmentItemId}/assignments`,
    data: { assignmentMappings },
  });

  return data;
};

export const getGradesByAssessmentItemId = async ({
  assessmentItemId,
  accessToken,
}) => {
  const { data } = await assessmentItemsApi({
    method: 'get',
    url: `${BASE_URL}/${assessmentItemId}/grades`,
    accessToken,
    withCredentials: true,
  });

  return data;
};

export const createExportJob = async ({
  assessmentItemId,
  overrides,
  accessToken,
}) => {
  const { data } = await assessmentItemsApi({
    method: 'post',
    accessToken,
    url: `${BASE_URL}/${assessmentItemId}/export-grades`,
    data: { overrides },
    withCredentials: true,
  });

  return data;
};

export const getGradesByStudentId = async ({
  studentId,
  assessmentItemId,
  accessToken,
}) => {
  const { data } = await assessmentItemsApi({
    method: 'get',
    accessToken,
    url: `${BASE_URL}/${assessmentItemId}/grades`,
    params: {
      student: studentId,
    },
    withCredentials: true,
  });

  if (!data.grades || !data.grades[0]) {
    return null;
  }

  return {
    assessmentItemId,
    // request using studentId will result in an array of grades with one item
    studentGrade: data.grades[0],
  };
};
